
import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { obtenerSimulacionExportador } from '../../actions/listados'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import * as TABLAS from '../../../../config/tables'
import { parseEntityId } from '../../../../models/entity'

function CampoExportadorSimulacion (props) {
  const { index, exportador, obtenerSimulacionExportador } = props

  useEffect(() => {
    if (exportador) {
      obtenerSimulacionExportador(parseEntityId(exportador), index)
    }
  }, [exportador, obtenerSimulacionExportador, index])

  return (
    <Col md={12} key={index} style={{ padding: 0 }}>
      <MuiTable id={TABLAS[`TABLA_SIMULACION_${index}`]} />
    </Col>
  )
}

const mapActionsToProps = {
  obtenerSimulacionExportador
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CampoExportadorSimulacion)
